import * as React from 'react'
import cn from 'classnames'
import Image from 'next/image'

import Rocket from './rocket.svg'

import styles from './ExpressDeliveryTag.module.css'

type ExpressDeliveryTagProps = {
  expressDelivery?: '1h' | '24h'
}

const ExpressDeliveryTag: React.FC<ExpressDeliveryTagProps> = ({
  expressDelivery,
}) => {
  return (
    <div
      className={cn(styles.expressDeliveryTagContainer, {
        [styles.expressDeliveryTagContainer1h]: expressDelivery === '1h',
      })}
    >
      <Image src={Rocket} width={16} height={16} alt="Express Delivery" />
      <span className={styles.expressDeliveryTagText}>
        {`${expressDelivery} Delivery`}
      </span>
    </div>
  )
}

export default ExpressDeliveryTag
